<template>
  <div>
    <v-dialog
      v-model="shiftPopupDialog"
      full-width
      max-width="600px"
    >
      <v-btn
        :color="color"
        slot="activator"
        block
        @click="retrieveNotes"
      >
        <v-icon left>
          speaker_notes
        </v-icon>
        {{ buttonText }}
      </v-btn>
      <v-card class="pa-3">
        <v-flex v-if="notes.length == 0 && (user.id == shift.userId)" xs12>
          <v-textarea
            label="My Notes"
            v-model="newNote"
            auto-grow
            box
          >
          </v-textarea>
          <v-btn @click="createNote">Add Note</v-btn>
        </v-flex>
        <v-flex v-for="note in notes" xs12>
          <ApiField
            v-if="note.userId == user.id"
            fieldType="textarea"
            storeAction="shifts/updateNote"
            storeUpdate="shifts/refreshNotes"
            paramName="shift_note"
            :object="note"
            fieldName="note"
            :storeFieldValue="note.note"
            label="My Notes"
          >
          </ApiField>
          <v-btn v-if="note.userId == user.id" @click="">Update Note</v-btn>

          <v-textarea
            v-if="note.userId != user.id"
            :value="note.note"
            :label="`${ note.authorName }'s Notes (${ note.authorRole })`"
            auto-grow
            box
            disabled
          >
          </v-textarea>
        </v-flex>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ApiField from '@/components/base/api-field.vue'

export default {
  props: [
    'user',
    'shiftId',
    'shift',
    'color',
    'buttonText',
    'maxWidth',
  ],
  components: {
    ApiField,
  },
  computed: {
    ...mapState('shifts', [
      'currentUserCurrentShift',
      'notes'
    ]),
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {
      shiftPopupDialog: false,
      apiCallPending: false,
      restricted: true,
      newNote: '',
    }
  },
  methods: {
    createNote () {
      this.$store.dispatch('shifts/createNote', {
        shiftId: this.shiftId,
        userId: this.user.id,
        note: this.newNote
      })
      .then(res => {
        this.shiftPopupDialog = false
      })
    },
    closeDialog () {
      this.shiftPopupDialog = false
    },
    retrieveNotes () {
      this.$store.dispatch('shifts/getNotes', { shiftId: this.shiftId })
    },
  },
}
</script>

<style scoped>
</style>
